export default "__VITE_ASSET__CzWaeSKx__"